import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import libraryScheduleItemData from './libraryScheduleItemData';
import { Button, message, Popconfirm, Card, Checkbox, Col, DatePicker, Form, Input, Row, Select, InputNumber } from 'antd';
import GoBackLink from '../../../../../../components/common/GoBackLink';
import PageHeading from '../../../../../../components/common/PageHeading';
import { BulbOutlined, CloseOutlined, CopyOutlined, DownCircleFilled, EditOutlined, UserOutlined } from '@ant-design/icons';
import HeaderDrop from '../HeaderDrop';
import AssignMembersDropdown from '../AssignMembersDropdown';

const LibraryScheduleItemPage = () => {
  const [libraryScheduleData, setLibraryScheduleData] = useState({});
  const { id } = useParams();
  const { Option } = Select;

  const [selectedMembers, setSelectedMembers] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedRepeats, setSelectedRepeats] = useState('');
  const [hideField, setHideField] = useState(true);
  const [repeatOn, setRepeatOn] = useState(false);
  const [repeatBy, setRepeatBy] = useState(false);
  const [shownLink, setShownLink] = useState(false);
  const [repeatsEvery, setRepeatsEvery] = useState(false);
  const [repeatOnn, setRepeatOnn] = useState(false);
  const [yearsMonthsText, setYearsMonthsText] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const [daysShown, setDaysShown] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleCheckboxChange = (day, isChecked) => {
    if (isChecked) {
      setSelectedDays([...selectedDays, day]);
    } else {
      setSelectedDays(selectedDays.filter((d) => d !== day));
    }
  };

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const handleMemberSelect = (value) => {
    setSelectedMembers(value);
  };

  const selectWorkflow = [
    {
      value: '2701 NW 16th ST Maschino, Logan',
    },
    {
      value: 'Move Out',
    },
    {
      value: 'Pay/Quit',
    },
    {
      value: 'Lease Renewel',
    },
    {
      value: 'P: Pay/Quit',
    },
  ];

  const selectTimeZone = [
    {
      value: '(UTC+00:00) Africa/Abidjan [GMT]',
    },
    {
      value: '(UTC+01:00) Africa/Accra [GMT]',
    },
    {
      value: '(UTC+02:00) Africa/Algiers [GMT]',
    },
    {
      value: '(UTC+03:00) Africa/Bissau [GMT]',
    },
    {
      value: '(UTC+04:00) Africa/Cairo [GMT]',
    },
  ];

  const selectRepeatsTimePeriod = [
    {
      value: 'Nope',
    },
    {
      value: 'Yearly',
    },
    {
      value: 'Monthly',
    },
    {
      value: 'Weekly',
    },
    {
      value: 'Daily',
    },
  ];
  const handleFormSubmit = (values) => {
    console.log('Form values:', values);
  };
  const onChangeInputNum = (value) => {
    console.log('changed', value);
  };
  const names = [
    {
      value: 'Rimsha Naeem',

    },
    {
      value: 'Usama Alks',
    },
    {
      value: 'Alisha SSS',
    }

  ];
  const renderMemberOption = (name) => {
    const nameParts = name.value.split(' ');
    const firstNameInitial = nameParts[0].charAt(0);
    const lastNameInitial = nameParts[nameParts.length - 1].charAt(0);
    const initials = firstNameInitial + lastNameInitial;

    return (
      <Option key={name.value} value={name.value}>
        <span
          style={{
            display: 'inline-block',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: '#dddddd',
            marginRight: '8px',
            textAlign: 'center',
            lineHeight: '24px',
            fontSize: '14px',
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          {initials}
        </span>
        {name.value}
      </Option>
    );
  };

  const handleRepeatsSelect = (value) => {
    setSelectedRepeats(value);
    console.log("valuevalue", value)
    if (value === 'Nope') {
      setHideField(true)
      setRepeatsEvery(true)
      setYearsMonthsText(" ")
      setShownLink(false)
      setDaysShown(false)

    }
    if (value === 'Yearly') {
      setHideField(false)
      setRepeatBy(false)
      setRepeatsEvery(true)
      setShownLink(false)
      setDaysShown(false)

      setYearsMonthsText("year(s)")
    }
    if (value === 'Monthly') {
      setHideField(false)
      setRepeatsEvery(true)
      setShownLink(false)
      setDaysShown(false)

      setRepeatBy(true)
      setYearsMonthsText("month(s)")
    }
    if (value === 'Weekly') {
      setHideField(false);
      setRepeatBy(false)
      setRepeatsEvery(true)
      setShownLink(false)
      setDaysShown(false)

      setRepeatOn(false)
      setYearsMonthsText("week(s)")
    }
    if (value === 'Daily') {
      setHideField(false);
      setRepeatBy(false)
      setRepeatOn(false)
      setRepeatsEvery(true)
      setShownLink(true)
      setYearsMonthsText("day(s)")
      setDaysShown(true)
      setSelectedDays([])

    }
  };

  const repeatsOning = () => {
    setRepeatOnn(true)
    setHideField(false)
    setRepeatOn(true)
    setRepeatBy(false)
    setRepeatsEvery(false)
  }
  console.log("libraryScheduleItemData", libraryScheduleData)
  useEffect(() => {
    const newObject = libraryScheduleItemData.find((item) => {
      return item.key === Number(id);
    });

    setLibraryScheduleData(newObject);
  }, [id]);

  return (
    <div className="page-container">
      <div className="main-container">
        <PageHeading heading="WORKFLOW SCHEDULIN' TIME" />

        <Row >
          <Col>
            <p style={{ color: ' gray', fontSize: '14px', margin: '10px' }}><b><BulbOutlined style={{ fontWeight: 'bold' }} /> ProTip:</b> You can schedule a workflow to be started on a certain date, or to repeat daily, weekly, monthly or yearly.</p>
          </Col>
          <Col span={24}>
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
              onFinish={handleFormSubmit}
            >

              <Form.Item label="Workflow" required name="workflow">
                <Select options={selectWorkflow} defaultValue={libraryScheduleData?.workflow || {}} />
              </Form.Item>

              <Form.Item label="name" name="name">
                <Input
                  placeholder="name"
                  value={libraryScheduleData?.firstName}
                  suffix={<HeaderDrop />}
                />
              </Form.Item>

              <Form.Item label="Assignees" name="assignees">
                <p> {selectedMembers.length > 0 ? selectedMembers.map((name) => {
                  const nameParts = name.split(' ');
                  const firstNameInitial = nameParts[0].charAt(0);
                  const lastNameInitial = nameParts[nameParts.length - 1].charAt(0);
                  const initials = firstNameInitial + lastNameInitial;
                  return <span style={{
                    borderRadius: '50%', padding: '6px 5px', color: 'white',
                    backgroundColor: '#dddddd'
                  }}>{initials}</span>;
                }).reduce((prev, curr) => [prev, '', curr], []) : <>{libraryScheduleData?.assignees}</>}</p>


              </Form.Item>

              <Form.Item label=" ">

                <Button onClick={togglePopup}>
                  <UserOutlined /> Assign members
                </Button>
                {isOpen && (
                  <div className='card-container-div' style={{
                    position: '', bottom: '10px', right: '10px', border: '1px solid light gray',
                    height: '200px', width: '300px', display: 'flex', alignItems: 'center',
                    padding: '10px',
                    flexDirection: 'column'
                  }}>
                    <div style={{
                      display: 'flex', justifyContent: 'space-between', width: '100%'

                    }}>
                      <p>  </p>
                      <p style={{ color: 'gray', margin: 0 }}>ASSIGN USERS</p>
                      <CloseOutlined style={{ cursor: 'pointer' }} onClick={togglePopup} />
                    </div>


                    <hr className='hr-line' style={{ width: '100%', margin: '10px' }} />

                    <Select
                      mode="multiple"
                      placeholder="Select members"
                      value={selectedMembers}
                      onChange={handleMemberSelect}
                      style={{ width: '100%' }}
                      renderOption={renderMemberOption}
                    >
                      {names.map((name) => renderMemberOption(name))}
                    </Select>
                    <p style={{
                      display: 'flex', color: 'gray', alignItems: '', justifyContent: 'center',
                      padding: '10px',
                    }}>Search for a person in your organization by name or email address.</p>
                  </div>
                )}
              </Form.Item>

              <Form.Item label="Repeats" name="repeats">
                <Select style={{ width: '150px' }} defaultValue="Nope" options={selectRepeatsTimePeriod} onChange={handleRepeatsSelect} />
              </Form.Item>

              {repeatBy && !hideField && <Form.Item label="Repeat by" name="repeat by">
                <Select style={{ width: '150px' }} defaultValue="Nope" options={names} onChange={handleRepeatsSelect} />
              </Form.Item>}



              {!hideField && !repeatOn && repeatsEvery &&
                <Form.Item label="Repeat every" name="repeatEvery">
                  <Col style={{ display: 'flex' }} span={24}>
                    <InputNumber min={1} max={10} defaultValue={3} onChange={onChangeInputNum} />
                    <p style={{ marginTop: '5px', marginLeft: '10px' }}>
                      {yearsMonthsText}
                    </p>

                  </Col>
                  {shownLink && <a onClick={repeatsOning}> Select days of week to repeat</a>}
                </Form.Item>
              }

              {!hideField && !repeatsEvery && repeatOn && !repeatBy && repeatOnn && <Form.Item label="Repeats on" name="repeatOn">
                <Col span={16} style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Checkbox onChange={(e) => handleCheckboxChange('Sunday', e.target.checked)}>Sunday</Checkbox>
                  <Checkbox onChange={(e) => handleCheckboxChange('Monday', e.target.checked)}>Monday</Checkbox>
                  <Checkbox onChange={(e) => handleCheckboxChange('Tuesday', e.target.checked)}>Tuesday</Checkbox>
                  <Checkbox onChange={(e) => handleCheckboxChange('Wednesday', e.target.checked)}>Wednesday</Checkbox>
                  <Checkbox onChange={(e) => handleCheckboxChange('Thursday', e.target.checked)}>Thursday</Checkbox>
                  <Checkbox onChange={(e) => handleCheckboxChange('Friday', e.target.checked)}>Friday</Checkbox>
                  <Checkbox onChange={(e) => handleCheckboxChange('Saturday', e.target.checked)}>Saturday</Checkbox>
                </Col>
              </Form.Item>}

            

              <Form.Item label="Time Zone">
                <Col span={16}>
                  <Select options={selectTimeZone} defaultValue="(UTC+00:00) Africa/Abidjan [GMT]" />
                </Col>
              </Form.Item>


              <Form.Item label="Start date" required>
                <Col span={14}>
                  <DatePicker onChange={handleDateChange} />
                </Col>
              </Form.Item>


              <Form.Item label="Due after">
                <Row gutter={[0, 8]}>
                  <Col span={24} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Col span={8}>
                      <InputNumber style={{ width: '120px' }} min={1} max={10} defaultValue={0} onChange={onChangeInputNum} />
                      <p>year(s)</p>
                    </Col>

                    <Col span={8}>
                      <InputNumber style={{ width: '120px' }} min={1} max={10} defaultValue={0} onChange={onChangeInputNum} />
                      <p>month(s)</p>
                    </Col>
                    <Col span={8}>
                      <InputNumber style={{ width: '120px' }} min={1} max={10} defaultValue={0} onChange={onChangeInputNum} />
                      <p>day(s)</p>
                    </Col>

                  </Col>

                  <Col span={24} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Col span={8}>
                      <InputNumber style={{ width: '120px' }} min={1} max={10} defaultValue={1} onChange={onChangeInputNum} />
                      <p>hour(s)</p>
                    </Col>

                    <Col span={8}>
                      <InputNumber style={{ width: '120px' }} min={1} max={10} defaultValue={0} onChange={onChangeInputNum} />
                      <p>minute(s)</p>
                    </Col>
                    <Col span={8}>
                      <Button>Remove</Button>
                    </Col>

                  </Col>
                </Row>

              </Form.Item>

              <hr className='hr-line' style={{ width: '100%', margin: '10px' }} />

              <Form.Item label="Summary" style={{ padding: '20px 0' }}>
                {selectedDate ? (
                  <p>{`Once on ${selectedDate.format('dddd')}, ${selectedDate.format('MMMM')} ${selectedDate.date()}`}</p>

                ) : 
                 <>
                { 
                  !daysShown ? 
                  `Every 1 ${yearsMonthsText} on Aug 18`: 
                  <div style={{display: 'flex', marginLeft: '3px'}} >
                Every 1 {yearsMonthsText} on day,                 
{selectedDays.length > 0 && selectedDays.map((day) => (
  <p style={{marginLeft: '4px'}} key={day}>{day}</p>
))}
{selectedDays.length === 0 && <p type="secondary"></p>}
                  </div>
                }
                </>
                }
              </Form.Item>

              <hr className='hr-line' style={{ width: '100%', margin: '10px' }} />

            </Form>
            <Col span={24} style={{
              display: 'flex', justifyContent: 'center',
              alignItems: 'center', margin: 'auto', padding: '20px 0'
            }}>

              <Button style={{ marginLeft: '10px' }} ><GoBackLink style={{ marginTop: '10px', color: 'black' }} link="" /></Button>
              <Button style={{ marginLeft: '10px' }} type="primary"> <EditOutlined />Update</Button>
              <Button style={{ marginLeft: '10px' }} > <CopyOutlined />Copy</Button>
              <Button style={{ marginLeft: '10px', background: 'red', color: 'white' }} > <CloseOutlined /> Delete</Button>

            </Col>
          </Col>

        </Row>
      </div>
    </div>
  )
}

export default LibraryScheduleItemPage;
